import { BorderRadius, Button, ButtonsGroup } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { useSandboxBankTransactionsFilters } from '../../../../hooks/useSandboxBankTransactionsFilters'
import { statusFilterButtons } from './consts/statusFilterButtons'

export const BankTransactionsStatusFilter = (): ReactElement => {
  const { t } = useTranslation()
  const [{ statusFilter }, setFilters] = useSandboxBankTransactionsFilters()

  return (
    <ButtonsGroup>
      {statusFilterButtons.map(({ status, label }) => (
        <Button
          key={status}
          variant={statusFilter === status ? 'filled' : 'outlined'}
          onClick={() => setFilters({ statusFilter: status })}
          borderRadius={BorderRadius.R10}
          color={statusFilter === status ? 'accent' : 'primary'}
        >
          {t(label)}
        </Button>
      ))}
    </ButtonsGroup>
  )
}
